<template>
  <div>
    <div class="position-relative">
      <section class="section  section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container p-0">

          <!-- 最新訂單才有的篩選列（日期／關鍵字），其他共用此頁的路由不顯示 -->
          <!-- 兩個篩選列各自獨立（不同 key），切換頁面時不會把上一頁的日期選擇帶過來 -->
          <CatalogFilterBar v-if="isLatest" key="latest-filter" :fetch-dates="Api.getLatestDates" @change="onFilterChange"/>
          <CatalogFilterBar v-if="isPast" key="past-filter" :fetch-dates="Api.getPastDates" :date-fields="['final_date']" @change="onFilterChange"/>

          <div v-if="showCount && items.length > 0" class="text-main-color font-weight-500 text-center font-size-18">
            共有 {{ total_counts }} 項結果
            <div class="mt-3"></div>
          </div>

          <!-- 沒有資料時的空狀態提示（讀取完成後才顯示，避免資料還沒回來就先閃一下空狀態） -->
          <div class="bg-white p-3 rounded-3" v-if="is_init && items.length===0">
            <h2 class="display-3 text-custom-text">{{ title }}</h2>
            <div class="mt-4"></div>
            <p class="text-main-color font-weight-500 text-center font-size-18 m-0">{{ emptyMessage }}</p>
            <div class="mt-3"></div>
          </div>

          <div class="bg-white p-3 rounded-3" v-if="items.length>0">
            <div class="">
              <h2 class="display-3 text-custom-text ">{{ title }}</h2>
            </div>
            <div class="mt-3"></div>
            <div class="grid-container mx-5">
              <div v-for="(item, index) in items" :key="index" class="grid-item">
                <CatalogItem style="width: 212px;" :item="item"/>
              </div>
            </div>
            <IntersectionObserver
                sentinal-name="sentinal-name"
                @on-intersection-element="onIntersectionElement"
            ></IntersectionObserver>
            <div  v-if="isLoadMore || finished" class="d-flex w-100 mt-3 justify-content-center align-items-center">
              <b-spinner v-if="isLoadMore" label="Loading..."></b-spinner>
              <p v-if="finished">已無更多資料</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  </div>
</template>

<script>

import CatalogItem from "@/views/components/elements/CatalogItem";

import {checkError} from "@/util/error_handler";
import {getMediaUrl, isEmpty} from "@/util/helpers";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
import CatalogFilterBar from "@/components/CatalogFilterBar.vue";
import * as Api from "@/util/http_api";

export default {
  name: "CatalogView",
  components: {
    IntersectionObserver,
    CatalogFilterBar,
    CatalogItem: CatalogItem,
  },
  props: {
    showCount: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
    this.updateTitle();
  },
  data() {
    return {
      Api,
      // 最新訂單篩選列回報的條件（預設「全部」＝不篩日期）
      latestFilters: {keyword: '', dateField: undefined, dateValue: undefined},
      filterRouteName: null,
      title: '',
      url: this.$url + 'model/catalogs',
      isLoading: true,
      finished: false,
      items: [],
      total_counts: 0,
      is_show: false,
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 24,
      },
      isIntersectingElement: false,
      isLoadMore: false,
      is_init: false,
    };
  },
  computed: {
    isLatest() {
      return this.$route.name === 'latest' && !this.$route.query.commodity_brand_id;
    },
    isPast() {
      return this.$route.name === 'past' && !this.$route.query.commodity_brand_id;
    },
    emptyMessage() {
      if (this.$router.currentRoute.name === 'favorite') {
        return '你還沒有收藏任何型錄，點選型錄卡片右上角的愛心即可收藏';
      }
      return '沒有搜尋結果';
    },
  },
  watch: {
    '$route.query'() {
      // 切換到不同的頁面（例如過往訂單 → 最新訂單）：篩選條件回到「全部」，不沿用上一頁的日期
      if (this.$route.name !== this.filterRouteName) {
        this.filterRouteName = this.$route.name;
        this.latestFilters = {keyword: '', dateField: undefined, dateValue: undefined};
      }
      this.items = [];
      this.finished = false;
      this.total_counts = 0;
      this.is_init = false;
      this.updateTitle();
      this.getDataFromApi();
    },
  },
  async created() {
    if (this.sort !== undefined) {
      this.options.sortBy = this.sort.sortBy;
      this.options.sortDesc = this.sort.sortDesc;
    }
    await this.parseQuery(false);
    await this.getDataFromApi();
    this.is_init = true;
  },
  methods: {
    // 篩選條件改變：重置列表後重新查第一頁
    async onFilterChange(filters) {
      this.latestFilters = filters;
      this.items = [];
      this.finished = false;
      this.total_counts = 0;
      this.is_init = false;
      await this.getDataFromApi();
      this.is_init = true;
    },
    updateTitle() {
      if (this.$route.query.commodity_brand_id) {
        this.title = '品牌型錄';
        return;
      }
      switch (this.$router.currentRoute.name) {
        case 'top_rank':
          this.title = '熱門排行';
          break;
        case 'latest':
          this.title = '最新訂單';
          break;
        case 'past':
          this.title = '過往訂單';
          break;
        case 'closing_soon':
          this.title = '即將結單';
          break;
        case 'interest':
          this.title = '您感興趣';
          break;
        case 'favorite':
          this.title = '我的收藏';
          break;
      }
    },
    getMediaUrl: getMediaUrl,
    onIntersectionElement(value) {
      console.log('onIntersectionElement : ', value);
      this.isIntersectingElement = value;
      this.loadMore();
    },
    async loadMore() {
      if (this.isLoadMore || this.finished) return;
      this.isLoadMore = true;
      console.log('start load more');
      let data = await this.getItemTable([this.items.length, this.items.length + this.options.itemsPerPage - 1]);
      console.log('more data : ' + data.items.length);
      for (let i = 0; i < data.items.length; i++) {
        this.items.push(data.items[i]);
      }
      this.isLoadMore = false;
      this.finished = this.items.length === this.total_counts;
    },
    async parseQuery(isUpdate) {
      // console.log('parseQuery : ' + isUpdate);
      this.items = [];
      if (this.$route.query.limit !== undefined && this.$route.query.offset !== undefined) {
        // console.log('modify page');
        let limit = parseInt(this.$route.query.limit);
        let offset = parseInt(this.$route.query.offset);
        this.page = this.options.page = Math.floor(offset / limit) + 1;
        this.itemsPerPage = this.options.itemsPerPage = limit;
      } else {
        this.itemsPerPage = this.options.itemsPerPage = 24;
        this.page = this.options.page = 1;
      }
      if (!!isUpdate) {
        await this.getItemTable();
      }
      // console.log('parseQuery finish');
    },
    async getDataFromApi() {
      // console.log('getDataFromApi');
      this.loading = true
      try {
        let data = await this.getItemTable()
        this.items = data.items
        this.total_counts = data.total
      } catch (e) {
        console.log(e);
      }
      this.loading = false
    },
    async getItemTable(range) {
      // console.log('=== getItemTable');
      let {
        sortBy,
        sortDesc,
        page,
        itemsPerPage,
      } = this.options

      if (page === undefined) page = 1;

      let sort = [];
      let filter = {};
      for (let i = 0; sortBy !== undefined && sortDesc !== undefined && i < sortBy.length && i < sortDesc.length; i++) {
        let list = [];
        list.push(sortBy[i]);
        list.push(sortDesc[i] ? 'DESC' : 'ASC');
        sort.push(list);
      }
      switch (this.$router.currentRoute.name) {
        case 'top_rank':
          this.title = '熱門排行';
          break;
        case 'latest':
          sort.push(['updated_at', 'DESC']);
          sort.push(['publish_date', 'DESC']);
          sort.push(['id', 'DESC']);
          filter['final_date.start'] = new Date();
          // 篩選列選了日期欄位／日期：用整天範圍比對（台灣時區，理由同 getHistoryCatalogs）
          // 最新訂單的「依發布日期」實際比對更新日期（updated_at）
          if (this.latestFilters.dateField && this.latestFilters.dateValue) {
            const {dateValue} = this.latestFilters;
            const field = this.latestFilters.dateField === 'publish_date' ? 'updated_at' : this.latestFilters.dateField;
            filter[`${field}.gte`] = `${dateValue}T00:00:00+08:00`;
            filter[`${field}.lte`] = `${dateValue}T23:59:59+08:00`;
          }
          if (this.latestFilters.keyword) filter['q'] = this.latestFilters.keyword;
          break;
        case 'past':
          // 過往訂單：已結單的型錄（截止日已過），最新結單的排前面
          sort.push(['final_date', 'DESC']);
          sort.push(['id', 'DESC']);
          filter['final_date.end'] = new Date();
          if (this.latestFilters.dateField && this.latestFilters.dateValue) {
            const {dateField, dateValue} = this.latestFilters;
            filter[`${dateField}.gte`] = `${dateValue}T00:00:00+08:00`;
            filter[`${dateField}.lte`] = `${dateValue}T23:59:59+08:00`;
          }
          if (this.latestFilters.keyword) filter['q'] = this.latestFilters.keyword;
          break;
        case 'closing_soon':
          sort.push(['final_date', 'ASC']);
          sort.push(['id', 'DESC']);
          filter['final_date.start'] = new Date();
          break;
        case 'interest':
          filter['final_date.start'] = new Date();
          break;
        case 'favorite':
          // 收藏列表不強制過濾 final_date，讓已結單的收藏型錄也看得到
          sort.push(['id', 'DESC']);
          break;
      }

      let params_objects = {};
      if (this.$router.currentRoute.name === 'closing_soon') params_objects['closing_soon'] = 1;
      if (this.$router.currentRoute.name === 'favorite') params_objects['favorite'] = 1;
      if (sort.length > 0) params_objects['sort'] = JSON.stringify(sort);

      //TODO: 初始化要從 query 拿 filter 的參數
      if (isEmpty(this.$route.query) === false) {
        let query = Object.assign({}, this.$route.query);
        delete query.offset;
        delete query.limit;
        delete query.filter;
        // commodity_brand_id 用 .equal，其餘用 .include
        const updatedQueryParams = {};
        Object.keys(query).forEach(key => {
          if (key === 'commodity_brand_id') {
            updatedQueryParams[key] = query[key];
            params_objects['commodity'] = null;
            params_objects['tag'] = null;
          } else {
            updatedQueryParams[`${key}.include`] = query[key];
          }
        });
        filter = Object.assign(filter, updatedQueryParams);
      }

      if (this.is_search && this.search !== undefined && this.search !== null) {
        filter['q'] = this.search;
      }
      if (this.is_filter && Object.keys(this.previous_filter).length > 0) {
        let keys = Object.keys(this.previous_filter);
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          filter[key] = this.previous_filter[key];
        }
        filter['q'] = this.search;
      }

      if (Object.keys(filter).length > 0) {
        params_objects = Object.assign({filter: JSON.stringify(filter)}, params_objects);
      }

      if (range === undefined) range = [(page - 1) * itemsPerPage, page * itemsPerPage - 1];
      const limit = range[1] - range[0] + 1;
      const offset = range[0];
      // build listOptions to delegate HTTP to Api.getCatalogs
      const listOptions = {
        limit: limit,
        offset: offset,
        sorts: sort,
        filters: filter,
        params: params_objects,
      };
      const isTopRank = this.$router.currentRoute.name === 'top_rank';
      const data = isTopRank
        ? await Api.getTopRanks(limit, offset)
        : await Api.getCatalogs(listOptions);
      this.pageCount = Math.ceil(data.total / itemsPerPage);
      return {
        items: data.items,
        total: data.total,
      }
    },
  },
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;
}

.grid-item {
  padding: 0;
}

</style>
